import { FORM_MODES } from '../../../utils/constants';
import React, { useContext } from 'react';
export const StylovyzeFormContext = React.createContext({
    mode: FORM_MODES.UNDEFINED,
    stylovyzeFields: {},
    setStylovyzeFields: (() => { }),
});
export const useStylovyzeFormContext = () => useContext(StylovyzeFormContext);
export const useStylovyzeForm = () => {
    const stylovyzeForm = useStylovyzeFormContext();
    return stylovyzeForm;
};
export const useMode = () => useStylovyzeFormContext()?.mode;
